module.exports = __webpack_public_path__ + "media/images/btn_see_bookings_as_stallion_keeper-da020d470f0de159467443ac57805e92.gif";